import {FC} from 'react';
import cn from 'classnames';
import Image from 'next/image';

import {StepIntroLogoProps} from './types';

import styles from '../../styles.module.scss';

const StepIntroLogo: FC<StepIntroLogoProps> = ({
  affiliateLogo,
  isMyBankTracker,
  isCNN,
}) => {
  if (!affiliateLogo?.src.length) {
    return (
      <Image
        src="/static/img/affiliates/zoe-logo.svg"
        alt="Zoe logo"
        width={80}
        height={35}
      />
    );
  }

  return (
    <>
      <figure
        className={cn(styles.stepIntro__logo_affiliate, {
          [styles.stepIntro__logo_affiliate__modMyBankTracker]: isMyBankTracker,
          [styles.stepIntro__logo_affiliate__modCNN]: isCNN,
        })}>
        <Image
          src={affiliateLogo.src}
          alt="affiliate logo"
          layout="fill"
          style={{width: '100%', height: '100%'}}
          data-testid={affiliateLogo.testId}
        />
      </figure>
      <figure className={styles.stepIntro__logo_zoe}>
        <Image
          src="/static/img/affiliates/zoe-logo.svg"
          alt="Zoe logo"
          style={{width: '100%', height: '100%'}}
          layout="fill"
        />
      </figure>
    </>
  );
};

export default StepIntroLogo;
